<template>
    <sui-form @submit="onSubmit">
        <GlobalConfig fetchMethod="URL" />
        <FileConfig fetchMethod="URL" />
        <MediaConfig fetchMethod="URL" />
        <CronConfig />

        <div>
            <h2 is="sui-header">{{ $t('gateway.urlType.title') }}</h2>

            <sui-form-field>
                <sui-checkbox
                    :label="$t('gateway.urlType.hasMediasURL')"
                    v-model="activeGateway.configuration.urlConfiguration.hasMediaURL"
                />
            </sui-form-field>

            <sui-form-fields :fields="'two'">
                <sui-form-field>
                    <label>{{ $t('gateway.urlType.listingURL') }}</label>
                    <div class="ui labeled input">
                        <div class="ui label"><sui-icon name="bullseye violet small icon"></sui-icon></div>
                        <input
                            @focus="onInputFocus"
                            v-model="activeGateway.configuration.urlConfiguration.listingURL"
                            type="text"
                            placeholder="http://www.cosmosoft.fr/cosmoAPI/passerelle/passerelle2.php?xi=, ..."
                            required
                        />
                    </div>
                    <MetadataInputList :value="activeGateway.configuration.urlConfiguration.listingURL" property="urlConfiguration.listingURL"/>
                </sui-form-field>

                <sui-form-field>
                    <label>{{ $t('gateway.urlType.mediasURL') }}</label>
                    <div class="ui labeled input">
                        <div class="ui label"><sui-icon name="bullseye violet small icon"></sui-icon></div>
                        <input
                            @focus="onInputFocus"
                            v-model="activeGateway.configuration.urlConfiguration.mediaURL"
                            :disabled="isMediaInputURLDisabled"
                            type="text"
                            placeholder="http://www.cosmosoft.fr/cosmoAPI/passerelle/passerelle2.php?xi=, ..."
                            required
                        />
                    </div>
                    <MetadataInputList :value="activeGateway.configuration.urlConfiguration.mediaURL" property="urlConfiguration.mediaURL"/>
                </sui-form-field>
            </sui-form-fields>
        </div>

        <sui-divider section />
        <sui-button color="violet" fluid>{{ $t('common.save') }}</sui-button>
    </sui-form>
</template>

<script>
    import GlobalConfig from '@/components/gateway/fields/GlobalConfig';
    import MediaConfig from '@/components/gateway/fields/MediaConfig';
    import FileConfig from '@/components/gateway/fields/FileConfig';
    import CronConfig from '@/components/gateway/fields/CronConfig';
    import MetadataInputList from '@/components/gateway/MetadataInputList.vue';
    import store from '@/store';
    import { mapGetters } from 'vuex';

    export default {
        name: 'URLForm',
        components: {
            GlobalConfig,
            MediaConfig,
            FileConfig,
            CronConfig,
            MetadataInputList,
        },
        methods: {
            onInputFocus(e) {
                this.state.forms.gateway.currentSelectedInput = e.target;
            },
        },
        computed: {
            isMediaInputURLDisabled: {
                get() {
                    return this.activeGateway.configuration.urlConfiguration.hasMediaURL === false;
                },
            },
            state: {
                get() { return store.state; }
            },
            ...mapGetters(['activeGateway']),
        },
        props: {
            onSubmit: Function,
        }
    }
</script>